import { render, staticRenderFns } from "./DatatablePackReserve.vue?vue&type=template&id=0e1c5e7a"
import script from "./DatatablePackReserve.vue?vue&type=script&lang=js"
export * from "./DatatablePackReserve.vue?vue&type=script&lang=js"
import style0 from "./DatatablePackReserve.vue?vue&type=style&index=0&id=0e1c5e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports